<template>
  <div class="flex flex-col bg-white shadow rounded-lg text-center"
    v-if="masterclass">
    <div class="flex w-full m-0 lg:m-5 items-start mt-3">
      <div class="flex flex-col w-full md:w-1/3">
        <round-photo-and-name
          :person="masterclass.teacher"
          :isTeacher="true"
          containerClass="flex items-center flex-col w-full md:w-1/2"
          :textClass="'text-center'" />
      </div>

      <div class="flex flex-col w-full">
        <h1 class="flex justify-center font-bold pb-2 text-lg md:text-2xl uppercase items-center
          text-chocolate-academy-600">
          {{masterclass.title}}</h1>
        <masterclass-date :masterclass="masterclass" class="text-base lg:text-xl
        font-sans-serif text-chocolate-academy-600" />
        <div v-if="!isMasterclassTeacher" class="mt-10 mb-4 flex flex-col">
          <router-link to="/registration" v-if="!authenticated" class="
          bg-orange-academy-300 text-white w-64 rounded mx-auto text-xl p-2
          transform hover:scale-105">
              {{ $t('masterclass.registerNow') }}
          </router-link>
          <div v-if="authenticated && !studentIsRegisteredAtTheMasterclass" class="flex flex-col">
            <span class="mb-10" v-if="masterclass.freePlaces">
              {{ $t('masterclass.only') }}
              <strong> {{ masterclass.freePlaces }} </strong>
              {{ $t('masterclass.placesStill') }}
            </span>
            <button @click="joinMasterclass"
              class="bg-beige-academy-300 w-64 rounded mx-auto text-xl p-2 uppercase
              transform hover:scale-105">
                {{$t('masterclass.subscribe')}}
            </button>
          </div>
          <div v-if="studentIsRegisteredAtTheMasterclass">
            <div v-if="!masterclass.is_started" class="flex flex-col">
              <span
                class="font-semibold uppercase text-lg text-orange-academy-300 text-center">
                  {{$t('masterclass.alreadySubscribed')}}
              </span>
              <button @click="retireFromMasterclass"
                class="bg-beige-academy-300 w-48 rounded mx-auto text-sm p-2 mt-2 uppercase
                  transform hover:scale-105">
                    {{$t('masterclass.withdraw')}}
              </button>
            </div>
            <div v-else class="flex flex-col">
              <span
                class="font-semibold uppercase text-lg text-orange-academy-300 text-center">
                  {{$t('masterclass.is-started')}}
              </span>
              <button @click="joinMasterclassMeeting"
                class="bg-beige-academy-300 w-48 rounded mx-auto text-xl p-2 mt-2 uppercase
                  transform hover:scale-105">
                    {{$t('masterclass.participate')}}
              </button>
            </div>
          </div>
        </div>
      </div>
      <button class="self-end hover:text-orange-academy-300 transform hover:scale-110">
        <edit-icon v-if="isMasterclassTeacher && $route.params.id === masterclass.id" />
      </button>
    </div>
    <h2 class="w-full mt-8 shadow-lg bg-white p-4 rounded-lg">
      {{masterclass.description}}</h2>
    <div v-if="isMasterclassTeacher && !$route.params.id" class="w-full text-center">
      <router-link  :to="'/dashboard/masterclass/'+masterclass.id">
        <button class="bg-beige-academy-300 w-64 rounded mx-auto text-xl p-2 uppercase
        transform hover:scale-105 my-4 mt-10">
          {{$t('masterclass.open')}}
        </button>
      </router-link>
    </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import axios from 'axios';
import EditIcon from '@/components/graphics/EditIcon.vue';
import MasterclassDate from './MasterclassDate.vue';
import RoundPhotoAndName from '../graphics/RoundPhotoAndName.vue';

export default {
  props: ['masterclass'],

  components: {
    MasterclassDate,
    EditIcon,
    RoundPhotoAndName,
  },

  computed: {
    ...mapGetters({
      authenticated: 'auth/authenticated',
      user: 'auth/user',
    }),

    studentIsRegisteredAtTheMasterclass() {
      if (this.user && this.masterclass.students.find(
        (student) => student.id === this.user.student.id,
      )) {
        return true;
      }
      return false;
    },

    isMasterclassTeacher() {
      if (this.authenticated && this.user.teacher
       && this.masterclass.teacher_id === this.user.teacher.id) {
        return true;
      }
      return false;
    },
  },

  methods: {
    joinMasterclass() {
      axios.put(`/api/masterclasses/${this.masterclass.id}/students/${this.user.student.id}`).then(() => {
        this.$emit('updated-subscription');
      });
    },

    retireFromMasterclass() {
      axios.delete(`/api/masterclasses/${this.masterclass.id}/students/${this.user.student.id}`).then(() => {
        this.$emit('updated-subscription');
      });
    },

    joinMasterclassMeeting() {
      axios.get(`/api/masterclasses/1/join-url?username=${this.user.name}`).then(({ data }) => {
        window.location.href = data;
      }).catch(() => {
        this.createNotification('error', 'Something get wrong, please try again');
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  .shadow {
    --tw-shadow: 0 4px 6px -1px rgb(166, 145, 133), 0 2px 4px -1px rgb(166, 145, 133);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #A69185), var(--tw-ring-shadow, 0 0 #A69185),
    var(--tw-shadow);
  }
</style>
